// extracted by mini-css-extract-plugin
export default {"container":"about_container__ORqlU","inner":"about_inner__PUq0v"};